(function() {
    /**
     * Make a block clickable
     */
    $('.js24LinkBlock').each(function (_, element) {
        const $link = $(this).find('a');

        if ($link.length) {
            const url = $link.attr('href');
            const blank = $link.attr('target') == '_blank' ? true : false;

            $link.on('click', function(e) {
                e.preventDefault();
            });

            $(element).on('click', function() {
                if (blank == true) window.open(url);
                else window.location.href = url;
            });
        }
    });
})();
